import React from "react";

const PAIS_LABEL = { mexico: "México" };

const Step4 = ({ formData }) => {
  const {
    configProducto = "",
    organizacionNombre = "Tu Organización",
    organizacionPais = "mexico",
    organizacionLogotipo = null,
    nombre = "",
    apellidoPaterno = "",
    apellidoMaterno = "",
  } = formData;

  const adminName = [nombre, apellidoPaterno, apellidoMaterno].filter(Boolean).join(" ") || "Nombre del Administrador";

  const productoLabel = { cafe: "Café", cacao: "Cacao", miel: "Miel" }[configProducto] || configProducto || "No seleccionado";
  const paisLabel = PAIS_LABEL[organizacionPais] || organizacionPais;

  return (
    <div style={{ paddingBottom: "40px" }}>
      {/* HEADER */}
      <div className="mb-5">
        <h1 className="fw-bold mb-3" style={{ fontSize: "2.5rem", color: "#1a1a1a" }}>
          ¡Todo listo!
          <br />
          Empecemos a trabajar.
        </h1>
        <p className="text-muted mb-0" style={{ fontSize: "0.95rem", lineHeight: "1.6", color: "#666" }}>
          Tu espacio de trabajo ha sido configurado correctamente.
        </p>
      </div>

      {/* RESUMEN CARD */}
      <div className="row mb-5">
        <div className="col-12">
          <div
            className="card border-0"
            style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              boxShadow: "0 4px 24px rgba(15, 23, 42, 0.08)",
              overflow: "hidden",
              padding: "24px",
            }}
          >
            <div className="row g-0 align-items-start p-4 p-lg-5">

              {/* COLUMNA IZQUIERDA */}
              <div className="col-12 col-md-6" style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
                {/* Icono + Nombre */}
                <div>
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "16px",
                      backgroundColor: "#f8fafc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#526b08",
                      marginBottom: "0.75rem",
                    }}
                  >
                    <i className="fa fa-building" style={{ fontSize: "1.15rem" }} />
                  </div>
                  <span
                    className="text-uppercase d-block"
                    style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.25rem" }}
                  >
                    Resumen del espacio
                  </span>
                  <h3 className="fw-bold mb-0" style={{ fontSize: "1.25rem", color: "#111827" }}>
                    {organizacionNombre}
                  </h3>
                </div>

                {/* Producto + País */}
                <div className="row g-3 pt-1">
                  <div className="col-6">
                    <span
                      className="text-uppercase d-block"
                      style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.35rem" }}
                    >
                      Producto principal
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa fa-seedling" style={{ color: "#16a34a", fontSize: "0.75rem", marginRight: "0.5rem" }}></i>
                      <span className="fw-semibold" style={{ fontSize: "0.875rem", color: "#374151" }}>
                        {productoLabel}
                      </span>
                    </div>
                  </div>
                  <div className="col-6">
                    <span
                      className="text-uppercase d-block"
                      style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.35rem" }}
                    >
                      País
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      <i className="fa fa-globe" style={{ color: "#526b08", fontSize: "0.75rem", marginRight: "0.5rem" }}></i>
                      <span className="fw-semibold" style={{ fontSize: "0.875rem", color: "#374151" }}>
                        {paisLabel}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* COLUMNA DERECHA */}
              <div
                className="col-12 col-md-6 mt-5 mt-md-0 ps-md-5"
                style={{ borderLeft: "1px solid #e5e7eb", display: "flex", flexDirection: "column", gap: "2rem" }}
              >
                {/* Logo si existe */}
                {organizacionLogotipo && (
                  <div>
                    <img
                      src={URL.createObjectURL(organizacionLogotipo)}
                      alt="Logo"
                      style={{ maxHeight: "60px", maxWidth: "160px", objectFit: "contain" }}
                    />
                  </div>
                )}

                {/* Tu acceso */}
                <div>
                  <span
                    className="text-uppercase d-block"
                    style={{ fontSize: "0.625rem", fontWeight: "700", color: "#9ca3af", letterSpacing: "0.2em", marginBottom: "0.75rem" }}
                  >
                    Tu acceso
                  </span>
                  <div
                    className="d-flex align-items-center"
                    style={{
                      backgroundColor: "rgba(82, 107, 8, 0.05)",
                      border: "1px solid #c9d98a",
                      borderRadius: "20px",
                      padding: "1rem 1.1rem",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#d4e39a",
                        color: "#526b08",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <i className="fa fa-user" style={{ fontSize: "1rem" }} />
                    </div>
                    <div>
                      <p className="fw-bold mb-1" style={{ fontSize: "0.875rem", color: "#1f2937" }}>
                        {adminName}
                      </p>
                      <p className="mb-0" style={{ fontSize: "0.7rem", color: "#526b08", fontWeight: "500" }}>
                        Administrador General
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* ¿QUÉ SIGUE AHORA? */}
      <div className="mb-5">
        <h5 className="fw-bold mb-4" style={{ color: "#8c98a4", fontSize: "0.9rem", letterSpacing: "0.5px" }}>
          ¿QUÉ SIGUE AHORA?
        </h5>

        <div className="row g-4">
          {/* PASO 1: Agenda */}
          <div className="col-12 col-md-6">
            <div
              className="card border-0 h-100"
              style={{ backgroundColor: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderRadius: "12px", padding: "24px" }}
            >
              <div className="d-flex gap-3">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#4a6502",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    flexShrink: 0,
                    marginRight: "1rem",
                  }}
                >
                  1
                </div>
                <div>
                  <h6 className="fw-bold mb-2" style={{ color: "#1a1a1a", fontSize: "1rem" }}>
                    Agenda una llamada con nosotros
                  </h6>
                  <p className="text-muted mb-3" style={{ fontSize: "0.85rem", lineHeight: "1.5" }}>
                    Nuestro equipo de soporte te contactará pronto para una sesión
                    personalizada, pero puedes adelantarte y elegir el horario que prefieras.
                  </p>
                  <a
                    href="#"
                    className="btn btn-sm fw-bold"
                    style={{
                      color: "#4a6502",
                      fontSize: "0.85rem",
                      border: "1px solid #4a6502",
                      borderRadius: "8px",
                      padding: "6px 16px",
                      textDecoration: "none",
                    }}
                  >
                    Ver horarios disponibles
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* PASO 2: Importa */}
          <div className="col-12 col-md-6">
            <div
              className="card border-0 h-100"
              style={{ backgroundColor: "#fff", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", borderRadius: "12px", padding: "24px" }}
            >
              <div className="d-flex gap-3">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    backgroundColor: "#9ca3af",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    flexShrink: 0,
                    marginRight: "1rem",
                  }}
                >
                  2
                </div>
                <div>
                  <h6 className="fw-bold mb-2" style={{ color: "#1a1a1a", fontSize: "1rem" }}>
                    Importa Productores, Parcelas y Mapas
                  </h6>
                  <p className="text-muted mb-3" style={{ fontSize: "0.85rem", lineHeight: "1.5" }}>
                    (Opcional) Carga tu padrón de socios, listado completo de parcelas o mapas
                    mediante archivos Excel o KML.
                  </p>
                  <p className="text-muted mb-3" style={{ fontSize: "0.75rem" }}>
                    <strong>Nota:</strong> Esta información puede tardarse unos días en verse
                    reflejada en tu cuenta.
                  </p>
                  <a href="#" className="fw-bold" style={{ color: "#4a6502", fontSize: "0.85rem", textDecoration: "none" }}>
                    <i className="fa fa-download me-1"></i> Subir archivos
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
